import { render, staticRenderFns } from "./VoucherDetail.vue?vue&type=template&id=313e852c&"
import script from "./VoucherDetail.vue?vue&type=script&lang=js&"
export * from "./VoucherDetail.vue?vue&type=script&lang=js&"
import style0 from "./VoucherDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports